import { CheckListRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * checklistSave - Function that saves on database a new ticket by department   
 * /tickets  
 * method POST  
 * @async-function
 */
const checkListSaveByVehicle = async (token: string, model: CheckListRequestType) => {
    const response = await api.post(
        `/checklists`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default checkListSaveByVehicle;